const baseSoundContent = {
  type: "audio",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "sound",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const createSoundEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseSoundContent,
    data: {
      ...baseSoundContent.data,
      key,
      value: "", // value remains empty as in the original
    },
    translation: {
      ...baseSoundContent.translation,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

const soundEntries = [
  { title: "Emoji Click", key: "emojiClick" },
  { title: "Point Score", key: "pointScore" },
  { title: "Emoji Submitted", key: "emojiSubmitted" },
  { title: "Share", key: "share" },
  { title: "Shuffle", key: "shuffle" },
  { title: "Winner Loading", key: "winnerLoading" },
  { title: "Default Positive", key: "defaultPostiveReward" },
  { title: "Default Negative", key: "defaultNegativeReward" },
  { title: "Auto Match", key: "autoMatchSound" },
  { title: "Claim Button", key: "claimButtonSound" },
  { title: "Revised Spin To Win", key: "revisedSpinToWin" },
];

const sounds = soundEntries.map(({ title, key }) => createSoundEntry(title, key));

export { sounds };
